import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import SelectChannel from '../../components/SelectChannel.vue'
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import { useStore } from '@/store'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelLog',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const userGroups = store.state.user.userInfo.group_id.split(',')
    const filters = reactive({
            coupon_id:'',//总库券包id
            batch:'',//入库批次
            card:'',//卡号
            out_batch:'',//出库批次
            channel_no:         '', 
            add_start_date:       '',// 出库开始日期
            add_end_date:       '',// 出库结束日期  
            return_start_date: '', // 退库开始日期
            return_end_date: '',/// 退库结束日期
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })

    const tableData = ref([])
    const total = ref(0)
    const state = reactive ({
        dialogVisibleFile : false,
    })
    const out = (type) => {
        if (filters.return_start_date && !filters.return_end_date || !filters.return_start_date && filters.return_end_date) {
            return proxy.$message({ type: 'error', message: '退库开始日期和退库结束日期需同时选择' })
        }
        window.open(`${Keys.baseUrl}/coupon/offline_coupon/warehouseOutboundList?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
    }
    //打开批量退券弹窗
    const openDialogFile = () => {
        state.dialogVisibleFile = true
    }
    const uploadRef = ref()
    // 关闭批量退券弹框
    const dialogBeforeCloseFile = () => {
        //清除数据
        uploadRef.value!.clearFiles()
        state.dialogVisibleFile = false
        getList()
    }
    const onUploadSuccess= async (res) => {
        const { code, data, msg } = res
        if(code == 200) {
            proxy.$message({ type: 'success', message: msg })
            dialogBeforeCloseFile()
            getList()
        } else {
            return proxy.$message({ type: 'error', message: msg })
        }
    }
    //确定上传
    const dialogSubmit= () => {
        proxy.$refs.uploadRef.submit()
    }
    // 获取列表数据
    const getList = () => {
        if (filters.return_start_date && !filters.return_end_date || !filters.return_start_date && filters.return_end_date) {
            return proxy.$message({ type: 'error', message: '退库开始日期和退库结束日期需同时选择' })
        }
        proxy.$http.get('/coupon/offline_coupon/warehouseOutboundList', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    const toBack = (ids) => {
        proxy.$confirm('是否确认退回', '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/coupon/offline_coupon/send_return_coupon', {ids}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: msg })
                getList()
            })
        }).catch(() => {
            console.log('取消')
        })
    }
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.coupon_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.coupon_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券包id",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.batch,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.batch) = $event)),
        modelModifiers: { trim: true },
        placeholder: "入库批次",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.out_batch,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.out_batch) = $event)),
        modelModifiers: { trim: true },
        placeholder: "出库批次",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.card,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.card) = $event)),
        modelModifiers: { trim: true },
        placeholder: "卡号",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.add_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.add_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.return_start_date,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.return_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "退库开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.return_end_date,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.return_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "退库结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (out(1)))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      (!_unref(userGroups).includes('45') && !_unref(userGroups).includes('75'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-btn",
            type: "primary",
            onClick: openDialogFile
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("批量退券")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_id",
          label: "券包id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "batch",
          label: "入库批次"
        }),
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "supplier_name",
          label: "供应商"
        }),
        (!_unref(userGroups).includes('45') && !_unref(userGroups).includes('75'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "card",
              label: "卡号"
            }))
          : _createCommentVNode("", true),
        (!_unref(userGroups).includes('45') && !_unref(userGroups).includes('75'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "password",
              label: "密码"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "channel_clearing_price",
          label: "渠道结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "厂家结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_type_text",
          label: "发票类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tax_point",
          label: "税点"
        }),
        _createVNode(_component_el_table_column, {
          prop: "validity_start_time",
          label: "有效期开始时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "validity_end_time",
          label: "有效期结束时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_batch",
          label: "出库批次"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_time",
          label: "出库时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "return_time",
          label: "退库时间"
        }),
        (!_unref(userGroups).includes('45') && !_unref(userGroups).includes('75'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "操作",
              fixed: "right",
              width: "120"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    disabled: scope.row.return_time,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toBack(scope.row.out_log_id))
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" 退券 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "批量退券",
      modelValue: state.dialogVisibleFile,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.dialogVisibleFile) = $event)),
      "before-close": dialogBeforeCloseFile
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeCloseFile }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          model: state.currRow,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: `/api/coupon/offline_coupon/except_return_coupon`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/coupon/offline_coupon/get_except_return`
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("下载批量退券模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})